// index.js

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./i18nextConf";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistration().then((reg) => {
        if (!reg && !sessionStorage.getItem("force-refresh")) {
            sessionStorage.setItem("force-refresh", "yes");
            //
            window.location.reload();
        }
    });
}

// let refreshing = false;
// if (navigator.serviceWorker) {
//     navigator.serviceWorker.addEventListener("controllerchange", () => {
//         if (refreshing) return;
//         refreshing = true;
//         window.location.reload();
//     });
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
